import { render, staticRenderFns } from "./module.glob.loader.vue?vue&type=template&id=43b18c21&"
import script from "./module.glob.loader.vue?vue&type=script&lang=js&"
export * from "./module.glob.loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports